
import { checkModulePermission } from '../../../../helpers/utilities';
import { NavLink, Link } from "react-router-dom";
import { Image } from "antd";
import closeImg from "../../../../assets/images/icon_menus/Close Button.svg";
import {
    adminMenus,
    deliveryMenus,
    productMenus,
    purchaseMenus,
    salesMenus,
    younoteAdminMenus
} from "../../../../config/constant";
import clsx from "clsx";
import customStyles from "../../../../assets/styles/customStyles";
//import Down from "../Icons/Down";

export const MobileMenus = (props) => {
    const { showCPModal, showEmailModal, showMobileModal, showLangModal, logoutUser } = props;

    const classes = customStyles();
    return (
        <div className={clsx(classes.mobileMenuContainer, { [classes.mobileMenuVisible]: props.mobileMenuVisible })}>
            <Link to={'#'} onClick={() => props.handleClose()} className={classes.CloseIcon}>
                <Image className={clsx(classes.disInline, classes.cursor)}
                    src={closeImg}
                    preview={false}
                />
            </Link>
            <ul className={classes.mobileMenu}>
                {
                    checkModulePermission(salesMenus.menu) &&
                    <li>
                        <div className={classes.mobileMenuGroup}>
                            <NavLink tabIndex={-1} onClick={() => props.handleClose()} to={salesMenus.link} activeClassName={classes.menuActive}>{salesMenus.menu}</NavLink>
                            {/* <div className={classes.downIconCustom}><Down /></div> */}
                        </div>
                        {/* {
                            salesMenus?.sub?.length > 0 &&
                            <ul className={classes.mobileMenuSub}>
                                {
                                    salesMenus.sub.map((menus, i) => (
                                        <li key={`main_sub_${i}`}>
                                            <div className={classes.mobileMenuGroup}>
                                                <NavLink tabIndex={-1} to={'#'}>{menus.menu}</NavLink>
                                                <div className={classes.downIconCustom}><Down /></div>
                                            </div>
                                            {
                                                menus?.sub?.length > 0 &&
                                                <ul className={classes.mobileMenuSub}>
                                                    {
                                                        menus?.sub?.map((submenu, i) => (
                                                            <li key={`sub_${i}`}>
                                                                {
                                                                    checkPermission(submenu.menu, 'Sales') && <>
                                                                        {
                                                                            submenu.onClick ? <NavLink tabIndex={-1} onClick={() => props.handleMenuOnClick(submenu.menu)} to={'#'}>{submenu.menu}</NavLink> : <NavLink tabIndex={-1} to={submenu.link}>{submenu.menu}</NavLink>
                                                                        }
                                                                    </>
                                                                }
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            }
                                        </li>
                                    ))
                                }
                            </ul>
                        } */}
                    </li>
                }
                {
                    checkModulePermission(purchaseMenus.menu) &&
                    <li>
                        <div className={classes.mobileMenuGroup}>
                            <NavLink tabIndex={-1} onClick={() => props.handleClose()} to={purchaseMenus.link} activeClassName={classes.menuActive}>{purchaseMenus.menu}</NavLink>
                            {/* <div className={classes.downIconCustom}><Down /></div> */}
                        </div>
                        {/* {
                            purchaseMenus?.sub?.length > 0 &&
                            <ul className={classes.mobileMenuSub}>
                                {
                                    purchaseMenus.sub.map((menus, i) => (
                                        <li key={`main_sub_${i}`}>
                                            <div className={classes.mobileMenuGroup}>
                                                <NavLink tabIndex={-1} to={'#'}>{menus.menu}</NavLink>
                                                <div className={classes.downIconCustom}><Down /></div>
                                            </div>
                                            {
                                                menus?.sub?.length > 0 &&
                                                <ul className={classes.mobileMenuSub}>
                                                    {
                                                        menus?.sub?.map((submenu, i) => (
                                                            <li key={`sub_${i}`}>
                                                                {
                                                                    checkPermission(submenu.menu, 'Purchase') && <>
                                                                        {
                                                                            submenu.onClick ? <NavLink tabIndex={-1} onClick={() => props.handleMenuOnClick(submenu.menu)} to={'#'}>{submenu.menu}</NavLink> : <NavLink tabIndex={-1} to={submenu.link}>{submenu.menu}</NavLink>
                                                                        }
                                                                    </>
                                                                }
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            }
                                        </li>
                                    ))
                                }
                            </ul>
                        } */}
                    </li>
                }
                {
                    checkModulePermission(deliveryMenus.menu) &&
                    <li>
                        <div className={classes.mobileMenuGroup}>
                            <NavLink tabIndex={-1} onClick={() => props.handleClose()} to={deliveryMenus.link} activeClassName={classes.menuActive}>{deliveryMenus.menu}</NavLink>
                            {/* <div className={classes.downIconCustom}><Down /></div> */}
                        </div>
                        {/* {
                            deliveryMenus?.sub?.length > 0 &&
                            <ul className={classes.mobileMenuSub}>
                                {
                                    deliveryMenus.sub.map((menus, i) => (
                                        <li key={`main_sub_${i}`}>
                                            <div className={classes.mobileMenuGroup}>
                                                <NavLink tabIndex={-1} to={'#'}>{menus.menu}</NavLink>
                                                <div className={classes.downIconCustom}><Down /></div>
                                            </div>
                                            {
                                                menus?.sub?.length > 0 &&
                                                <ul className={classes.mobileMenuSub}>
                                                    {
                                                        menus?.sub?.map((submenu, i) => (
                                                            <li key={`sub_${i}`}>
                                                                {
                                                                    checkPermission(submenu.menu, 'Delivery') && <>
                                                                        {
                                                                            submenu.onClick ? <NavLink tabIndex={-1} onClick={() => props.handleMenuOnClick(submenu.menu)} to={'#'}>{submenu.menu}</NavLink> : <NavLink tabIndex={-1} to={submenu.link}>{submenu.menu}</NavLink>
                                                                        }
                                                                    </>
                                                                }
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            }
                                        </li>
                                    ))
                                }
                            </ul>
                        } */}
                    </li>
                }
                {
                    checkModulePermission(productMenus.menu) &&
                    <li>
                        <div className={classes.mobileMenuGroup}>
                            <NavLink tabIndex={-1} onClick={() => props.handleClose()} to={productMenus.link} activeClassName={classes.menuActive}>{productMenus.menu}</NavLink>
                            {/* <div className={classes.downIconCustom}><Down /></div> */}
                        </div>
                        {/* {
                            productMenus?.sub?.length > 0 &&
                            <ul className={classes.mobileMenuSub}>
                                {
                                    productMenus.sub.map((menus, i) => (
                                        <li key={`main_sub_${i}`}>
                                            <div className={classes.mobileMenuGroup}>
                                                <NavLink tabIndex={-1} to={'#'}>{menus.menu}</NavLink>
                                                <div className={classes.downIconCustom}><Down /></div>
                                            </div>
                                            {
                                                menus?.sub?.length > 0 &&
                                                <ul className={classes.mobileMenuSub}>
                                                    {
                                                        menus?.sub?.map((submenu, i) => (
                                                            <li key={`sub_${i}`}>
                                                                {
                                                                    checkPermission(submenu.menu, 'Product') && <>
                                                                        {
                                                                            submenu.onClick ? <NavLink tabIndex={-1} onClick={() => props.handleMenuOnClick(submenu.menu)} to={'#'}>{submenu.menu}</NavLink> : <NavLink tabIndex={-1} to={submenu.link}>{submenu.menu}</NavLink>
                                                                        }
                                                                    </>
                                                                }
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            }
                                        </li>
                                    ))
                                }
                            </ul>
                        } */}
                    </li>
                }
                {
                    checkModulePermission(adminMenus.menu) &&
                    <li>
                        <div className={classes.mobileMenuGroup}>
                            <NavLink tabIndex={-1} onClick={() => props.handleClose()} to={adminMenus.link} activeClassName={classes.menuActive}>{adminMenus.menu}</NavLink>
                            {/* <div className={classes.downIconCustom}><Down /></div> */}
                        </div>
                        {/* {
                            adminMenus?.sub?.length > 0 &&
                            <ul className={classes.mobileMenuSub}>
                                {
                                    adminMenus.sub.map((menus, i) => (
                                        <li key={`main_sub_${i}`}>
                                            <div className={classes.mobileMenuGroup}>
                                                <NavLink tabIndex={-1} to={'#'}>{menus.menu}</NavLink>
                                                <div className={classes.downIconCustom}><Down /></div>
                                            </div>
                                            {
                                                menus?.sub?.length > 0 &&
                                                <ul className={classes.mobileMenuSub}>
                                                    {
                                                        menus?.sub?.map((submenu, i) => (
                                                            <li key={`sub_${i}`}>
                                                                {
                                                                    checkPermission(submenu.menu, 'Admin') && <>
                                                                        {
                                                                            submenu.onClick ? <NavLink tabIndex={-1} onClick={() => props.handleMenuOnClick(submenu.menu)} to={'#'}>{submenu.menu}</NavLink> : <NavLink tabIndex={-1} to={submenu.link}>{submenu.menu}</NavLink>
                                                                        }
                                                                    </>
                                                                }
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            }
                                        </li>
                                    ))
                                }
                            </ul>
                        } */}
                    </li>
                }
                {
                    checkModulePermission(younoteAdminMenus.menu) &&
                    <li>
                        <div className={classes.mobileMenuGroup}>
                            <NavLink tabIndex={-1} onClick={() => props.handleClose()} to={younoteAdminMenus.link} activeClassName={classes.menuActive}>{younoteAdminMenus.menu}</NavLink>
                            {/* <div className={classes.downIconCustom}><Down /></div> */}
                        </div>
                        {/* {
                            younoteAdminMenus?.sub?.length > 0 &&
                            <ul className={classes.mobileMenuSub}>
                                {
                                    younoteAdminMenus.sub.map((menus, i) => (
                                        <li key={`main_sub_${i}`}>
                                            <div className={classes.mobileMenuGroup}>
                                                <NavLink tabIndex={-1} to={'#'}>{menus.menu}</NavLink>
                                                <div className={classes.downIconCustom}><Down /></div>
                                            </div>
                                            {
                                                menus?.sub?.length > 0 &&
                                                <ul className={classes.mobileMenuSub}>
                                                    {
                                                        menus?.sub?.map((submenu, i) => (
                                                            <li key={`sub_${i}`}>
                                                                {
                                                                    checkPermission(submenu.menu, 'Sales') && <>
                                                                        {
                                                                            submenu.onClick ? <NavLink tabIndex={-1} onClick={() => props.handleMenuOnClick(submenu.menu)} to={'#'}>{submenu.menu}</NavLink> : <NavLink tabIndex={-1} to={submenu.link}>{submenu.menu}</NavLink>
                                                                        }
                                                                    </>
                                                                }
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            }
                                        </li>
                                    ))
                                }
                            </ul>
                        } */}
                    </li>
                }
                <li>
                    <div className={classes.mobileMenuGroup}>
                        <NavLink tabIndex={-1} onClick={() => props.handleClose()} to={'/my-profile'}>My Profile</NavLink>
                    </div>
                </li>
                <li>
                    <div className={classes.mobileMenuGroup}>
                        <NavLink tabIndex={-1} to={'#'} onClick={() => { showCPModal(); props.handleClose() }}>Change Password</NavLink>
                    </div>
                </li>
                <li>
                    <div className={classes.mobileMenuGroup}>
                        <NavLink tabIndex={-1} to={'#'} onClick={() => { showEmailModal(); props.handleClose() }}>Change Email ID</NavLink>
                    </div>
                </li>
                <li>
                    <div className={classes.mobileMenuGroup}>
                        <NavLink tabIndex={-1} to={'#'} onClick={() => { showMobileModal(); props.handleClose() }}>Change Mobile Number</NavLink>
                    </div>
                </li>
                <li>
                    <div className={classes.mobileMenuGroup}>
                        <NavLink tabIndex={-1} to={'#'} onClick={() => { showLangModal(); props.handleClose() }}>Change Language</NavLink>
                    </div>
                </li>
                <li>
                    <div className={classes.mobileMenuGroup}>
                        <NavLink tabIndex={-1} to={'#'} onClick={() => logoutUser()}>Logout</NavLink>
                    </div>
                </li>
                {/* <Menu.Item id={idNamingConversion('Change Password')} key={'change-password'} onClick={() => showCPModal()}>
                                    Change Password
                </Menu.Item>
                <Menu.Item id={idNamingConversion('Change Email ID')} key={'change-email-id'} onClick={() => showEmailModal()}>
                    Change Email ID
                </Menu.Item>
                <Menu.Item id={idNamingConversion('Change Mobile Number')} key={'change-mobile-number'} onClick={() => showMobileModal()}>
                    Change Mobile Number
                </Menu.Item>
                <Menu.Item id={idNamingConversion('Change Language')} key={'change-language'} onClick={() => showLangModal()}>
                    Change Language
                </Menu.Item> */}
            </ul>
        </div>
    )
}